<zoom-page-banner
    [icon]="data.banner?.icon"
    [title]="data.banner?.title"
    [subtitle]="data.banner?.subtitle"
    [link]="data.banner?.link"
></zoom-page-banner>
